<template>
  <v-container
    id="login"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          width="500"
        >
          <template v-slot:heading>
            <span class="text-center">Восстановление пароля</span>
          </template>
          <v-card-text class="text-center">
            <v-text-field
              v-model="form.phone"
              color="secondary"
              type="number"
              label="Телефон"
              :counter="11"
              maxlength="11"
              :rules="[(v) => (/7\d{10}/.test(v) || v.length == 0) || 'Неверное значение']"
              prepend-icon="mdi-phone"
              :disabled="sms.show || load"
            />

            <v-text-field
              v-if="sms.show"
              v-model="form.code"
              :disabled="load"
              class="mb-8"
              color="secondary"
              label="Введите код из смс для подтверждения регистрации"
              prepend-icon="mdi-lock-outline"
            />

            <v-text-field
              v-if="sms.show"
              v-model="form.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              color="secondary"
              label="Введите пароль"
              :rules="[rules.required, rules.min]"
              hint="минимум 6 символов"
              prepend-icon="mdi-lock-outline"
              class="input-group--focused"
              :disabled="load"
              @click:append="show1 = !show1"
            />
            <v-text-field
              v-if="sms.show"
              v-model="form.password2"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              color="secondary"
              label="Введите пароль"
              :rules="[rules.required, rules.min, this.form.password == this.form.password2 || ('Введенные пароли не совпадают')]"
              prepend-icon="mdi-lock-outline"
              class="input-group--focused"
              :disabled="load"
              @click:append="show2 = !show2"
            />
            <div
              v-if="alert.show"
              color="red"
            >
              <font color="red">
                {{ alert.error }}
              </font>
            </div>
            <v-btn
              v-if="!sms.show"
              color="primary"
              :disabled="form.phone.length<11"
              min-width="250"
              @click="send_sms"
            >
              Получить код из смс
            </v-btn>
            <v-btn
              v-else
              color="primary"
              :disabled="!form.code || form.code.length<4 || load"
              min-width="250"
              @click="recover"
            >
              Изменить пароль
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  import { setTimeout } from 'timers'
  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    data: () => ({
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || 'Поле обязательное.',
        min: v => v.length >= 6 || 'Миниум 6 символов',
      },
      alert: {
        show: false,
        error: '',
      },
      load: false,
      sms: {
        show: false,
      },
      sections: [
        {
          icon: 'mdi-chart-timeline-variant',
          iconColor: 'primary',
          title: 'Европротокол',
          text: `Вы можете заполнить информацию о ДТП и сгенерировать европротокол`,
        },
      ],
      form: {
        surname: '',
        patronymic: '',
        name: '',
        phone: '',
        password: '',
        password2: '',
        key: '',
        code: '',
        recover: true,
      },
    }),
    methods: {
      send_sms: function () {
        this.load = true
        this.axios.post('/api/auth/sms/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.load = false
              this.form.key = response.data.data
              this.sms.show = true
            } else {
              this.load = false
              this.alert.error = response.data.data || 'Ошибка'
              this.alert.show = true
              setTimeout(() => { this.alert.show = false }, 5000)
            }
          })
          .catch(e => {
            this.load = false
            this.alert.error = 'Ошибка'
            this.alert.show = true
            setTimeout(() => { this.alert.show = false }, 5000)
          })
      },
      recover: function () {
        this.load = true
        this.axios.post('/api/auth/recover/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.load = false
              this.$router.push('/pages/login')
            } else {
              this.load = false
              this.alert.error = response.data.data || 'Ошибка'
              this.alert.show = true
              setTimeout(() => { this.alert.show = false }, 5000)
            }
          })
          .catch(e => {
            this.load = false
            this.alert.error = 'Ошибка'
            this.alert.show = true
            setTimeout(() => { this.alert.show = false }, 5000)
          })
      },
    },
  }
</script>

<!--<style>
.theme--light.v-icon {
    color: green !important;
}
</style>-->
